import * as bootstrap from "bootstrap"

// make bootstrap available globally
window.bootstrap = bootstrap
